const COUNTRIES_API_REQUEST = "COUNTRIES/API_REQUEST";
const COUNTRIES_API_SUCCESS = "COUNTRIES/API_SUCCESS";
const COUNTRIES_API_FAILED = "COUNTRIES/API_FAILED";

export { COUNTRIES_API_REQUEST, COUNTRIES_API_SUCCESS, COUNTRIES_API_FAILED }